import { FC } from 'react';

import ticketshopRegionalTickets from './svg/ticketshopRegionalTickets.svg?url';

interface ITicketshopRegionalTicketsIconProps {
	/** Optional square size in px. Omitted → the icon's intrinsic 60×60. */
	size?: number;
}

export const TicketshopRegionalTicketsIcon: FC<
	ITicketshopRegionalTicketsIconProps
> = ({ size }) => {
	return (
		<img
			src={ticketshopRegionalTickets}
			alt="Regional tickets icon"
			width={size || undefined}
			height={size || undefined}
		/>
	);
};
